export default {
  namespaced: true,
  state: {
    queue: [],
    isRunning: false,
    currentMigration: null,
    messageLog: '',
    delayedMigrationTimer: null,
  },
  mutations: {
    pushMigration(state, migrationService) {
      state.queue.push(migrationService)
    },
    popMigration(state) {
      state.queue.shift()
    },
    setRunning(state, running) {
      state.isRunning = running
    },
    setCurrentMigration(state, migration) {
      state.currentMigration = migration
    },
    clearQueue(state) {
      state.queue = []
    },
    setMessageLog(state, message) {
      state.messageLog = message
    },
    clearMessageLog(state) {
      state.messageLog = ''
    },
    setDelayedMigrationTimer(state, timer) {
      state.delayedMigrationTimer = timer
    },
    clearDelayedMigrationTimer(state) {
      if (state.delayedMigrationTimer) {
        clearTimeout(state.delayedMigrationTimer)
        state.delayedMigrationTimer = null
      }
    },
  },
  getters: {
    hasQueueItems: (state) => state.queue.length > 0 || state.isRunning,
    isRunning: (state) => state.isRunning,
    currentMigration: (state) => state.currentMigration,
    queueLength: (state) => state.queue.length,
    messageLog: (state) => state.messageLog,
    hasDelayedMigration: (state) => state.delayedMigrationTimer !== null,
  },
  actions: {
    pushMigration({ commit, dispatch, rootState }, { migrator, route }) {
      commit('pushMigration', migrator)
      // Automatically start delayed migration when a migration is pushed
      if (route) {
        dispatch('startMigration', { route })
      }
    },
    async runMigration({ state, commit, dispatch, rootState }, { route } = {}) {
      if (state.isRunning || state.queue.length === 0) {
        return
      }

      commit('setRunning', true)
      let idx = 1

      const _runMigrations = async () => {
        const queue = [...state.queue]
        commit('clearQueue')

        while (queue.length > 0) {
          const migration = queue.shift()

          if (!migration) break

          commit('setCurrentMigration', migration)

          try {
            // Set store and route for the migration service
            migration.setStore(idx, this, route, rootState.revisions.siteRef)
            await migration.beforeMigration()
            await migration.runMigration()
            await migration.onCompleted()
            idx++
            // Migration successful, continue to next
          } catch (error) {
            console.error('Migration failed:', error)
            break
          }
        }
      }

      while (state.queue.length > 0) {
        await _runMigrations()
      }

      commit('setCurrentMigration', null)
      commit('setRunning', false)
      window.location.reload()
    },
    startMigration({ commit, dispatch, state }, { route } = {}) {
      // Clear any existing timer to reset the delay
      commit('clearDelayedMigrationTimer')

      // Set a new timer for 20 seconds
      const timer = setTimeout(() => {
        // Only start migration if there are items in the queue and not already running
        if (state.queue.length > 0 && !state.isRunning) {
          dispatch('runMigration', { route })
        }
        commit('clearDelayedMigrationTimer')
      }, 10000) // 10 seconds

      commit('setDelayedMigrationTimer', timer)
    },
    setMessageLog({ commit }, message) {
      commit('setMessageLog', message)
    },
    clearMessageLog({ commit }) {
      commit('clearMessageLog')
    },
    cancelDelayedMigration({ commit }) {
      commit('clearDelayedMigrationTimer')
    },
  },
}
